/**
 * @description product actions
 */

import * as service from '../../services/'
import * as util from '../../utils/'
import config from '../../config/'
import {types} from '../constants/types'
import MobileDetect from 'mobile-detect'
const md = new MobileDetect(window.navigator.userAgent)
const {SET_SECOND_PAYMETHOD_LIST, SELECT_SECOND_PAYMENT, UPDATE_ORDER_LIST, CLEAR_ORDER_LIST, UPDATE_SKU_LIST, SELECT_PAYMENT, SET_PAYMETHOD_LIST, SET_SKU_DETAIL, UPDATE_SUBIMT_COUPON} = types


export default {
  // 获取活动的商品
  getSkuList({rootState, commit, dispatch}) {
    let {client} = rootState
    return new Promise((resolve, reject) => {
      service.getSkuList({
        userId: client.user.userID
        , authType: config.authType
        , schemeNo: config.schemeNo
        , clientId: client.client.clientVersionId
      }).then(({data}) => {
        let {success} = data
        if (success) {
          let {datas} = data
          let skuList = datas[0].skuList
          commit(UPDATE_SKU_LIST, skuList)
          if (client.env === 'app') {
            dispatch('getBatchCommission', {skuList})
          }
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  // 获取单品佣金
  , getBatchCommission({commit, rootState}, {skuList}) {
    let arr = []
    skuList.forEach(val => {
      arr.push({
        entityTypeCode: val.entityTypeCode
        , salePrice: val.salePrice
        , skuId: val.skuId
      })
    })
    if (arr.length === 0) {
      return
    }
    return new Promise((resolve, reject) => {
      let {client} = rootState
      service.getBatchCommission({
        skuList: arr
        , clientId: client.client.clientVersionId
      }).then(({data}) => {
        let {success} = data
        if (success) {
          let {datas} = data
          let {commissionList} = datas
          if (commissionList.length > 0) {
            for (let i = 0; i < commissionList.length; i++) {
              if (commissionList[i].show === '1' && commissionList[i].commissionAmount && Number(commissionList[i].commissionAmount)) {
                for (let j = 0; j < skuList.length; j++) {
                  if (commissionList[i].skuId === skuList[j].skuId) {
                    skuList[j].commissionAmount = commissionList[i].commissionAmount
                    break
                  }
                }
              }
            }
            commit(UPDATE_SKU_LIST, skuList)
          }
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  // 请求商品
  , fetchProductDetail({rootState, commit, dispatch}, {productId, skuId}) {
    let {client} = rootState
    return new Promise((resolve, reject) => {
      service.getProductdetail({
        productId
        , userId: client.user.userID
        , clientId: client.client.clientVersionId // 客户端Id
        , channelId: client.client.channelId // 渠道Id
      })
        .then(res => {
          let {data} = res
          if (data.success && data.datas) {
            let {skus, attrs} = data.datas
            let verify = {}
            attrs.forEach((val) => {
              verify[val.attrCode] = val.attrValue
            })
            for (let i = 0; i < skus.length; i++) {
              if (skus[i].skuId === skuId) {
                skus[i] = Object.assign({}
                  , skus[i]
                  , {
                    productName: data.datas.productName
                    , productPic: data.datas.productPic
                    , sellingPrice: util.getSessionCache('salePrice') || skus[i].sellingPrice
                    , productDetail: data.datas.productDetail
                  }
                  , verify)
                // 更新单品
                commit(SET_SKU_DETAIL, skus[i])
                // 更新支付方式列表
                commit(SET_PAYMETHOD_LIST, {payMethodList: util.filterPayMethodList(data.datas.payMethodList, client.client.env, config.showCMBpay, config.showABCWallet)})
                dispatch('selectPayment', {index: 0})
                if (client.user.token && config.isCoupon === 'true') {
                  dispatch('fetchProductCoupon')
                }
                break;
              }
            }
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(e => reject(e))
    })
  }
  // 清空单品
  , resetSkuDetail({commit}) {
    // 更新单品
    commit(SET_SKU_DETAIL, {})
    commit(SET_PAYMETHOD_LIST, {payMethodList: []})
  }
  // 选择支付方式
  , selectPayment({commit}, {index}) {
    commit(SELECT_PAYMENT, {index})
  }
  // 提交订单
  , submit({commit, getters, dispatch, rootState}, {account, code}) {
    const path = window.location.origin + window.location.pathname
    const {product, client, coupon} = rootState
    const {payMethodList} = getters
    // y有登陆取填的地址列表无则新地址
    let selectedProduct = product.skuDetail
    // 推荐有礼参数
    let promoteData = util.getSessionCache('promoteData')
    const payReturnUrl = path + '#/result?state=success'
    let accountUserId = ''
    if(product.skuDetail.couponproduct && product.skuDetail.couponproduct === 'true'){
      accountUserId = client.user.userID
    }
    let data = {
      userId: client.user.userID,
      authToken: client.user.token,
      skuId: selectedProduct.skuId,
      channelSkuId: selectedProduct.id,
      // 微信用户openId
      channelAccount: client.user.unionId,

      channelId: client.client.channelId,
      clientVersionId: client.client.clientVersionId,

      num: '1',
      payMethodCode: payMethodList[product.paySelectedIndex].paymentMethodId,
      payMethodSubCode: product.paymentSubCode,
      payReturnUrl: payReturnUrl,
      unpayReturnUrl: path + '#/detail',
      ext: {
        account: accountUserId || account
        , userId: client.user.userID
      },
      otherProperties: {
        marketing: {
          authToken: client.user.token
          , authType: config.authType
          , userId: client.user.userID
        }
        , authToken: client.user.token
        , user_qr_code: code
      }
    }
    // 是否有优惠券信息
    if (coupon.couponInfo.couponNo) {
      data.coupons = [{
        couponNo: coupon.couponInfo.couponNo,
        couponType: coupon.couponInfo.couponMode,
        authType: config.authType
      }]
    }
    if (promoteData && promoteData.snCode) {
      data.otherProperties = Object.assign(data.otherProperties, {
        // 活动
        orderType: 4,
        // 推荐人
        referee: promoteData.snCode
      })
    }
    if (client.user.inviteCode) {
      data.otherProperties = Object.assign(data.otherProperties, {
        inviteCode: client.user.inviteCode
      })
    }
    if (client.user.cyUserId) {
      data.otherProperties.marketing = Object.assign(data.otherProperties.marketing, {
        cyAuthToken: client.user.cyAuthToken
        , cyAuthType: client.user.cyAuthType
        , cyUserId: client.user.cyUserId
      })
    }

    if (client.client.env === 'wxMini') {
      data.appId = client.user.appId
      data.channelAccountType = config.channelAccountType
      data.otherProperties = Object.assign(data.otherProperties, {
        openId: client.user.openId
      })
      data.payMethodSubCode = 'WXPAY_MINI'
    }
    // 中信全付通
    if (data.payMethodCode === 'CITIC_ALL_PAY') {
      // data.payMethodSubCode = 'CMBPAY_APP_JH'
      data.otherProperties.return_url = config.indexUrl
    }
    
    if (data.payMethodCode === 'CMBPAY') {
      // data.payMethodSubCode = 'CMBPAY_APP_JH'
      data.payMethodSubCode = client.client.env === 'app' ? 'CMBPAY_APP_JH' : 'CMBPAY_H5_JH'
    }
    // 改改改
    // 农行sdk支付
    if (data.payMethodCode === 'ABCPAY') {
      data.payMethodSubCode = client.client.env === 'app' ? 'ABCPAY_SDK' : config.ABCPaySubCode
    }
    // 彩之云
    if(data.payMethodCode === 'CZY_PAY'){
      data.payMethodSubCode = config.CZYPAYSubCode || data.payMethodSubCode
      data.otherProperties.mobile = account // 彩之云的 OpenId
      data.otherProperties.open_id = util.getSessionCache('czyopenid') // 彩之云的 OpenId
      data.otherProperties.return_url = payReturnUrl
    }
    // 前台支付
    if(data.payMethodCode === 'FRONT_PAYMENT'){
      data.payMethodSubCode = config.FRONTPAYMENTSubCode || data.payMethodSubCode
      data.otherProperties.return_url = payReturnUrl
      data.otherProperties.user_token = util.getSessionCache('AvicSToken') // '7176da06003b32d40071959d2e22da65'  // 超级前台的toke
    }
    // 花呗支付
    if (util.getSessionCache('payType') === 'hbPay') {
      data.otherProperties = {
        ...data.otherProperties,
        installment: '12', // 分期数， 暂时写死
        remark: {
          out_trade_risk_info: {
            mobile_operating_platform: md.mobile(),
            network: navigator.connection ? navigator.connection.effectiveType : '',
            sys_version: md.phone()
          }
        }
      }
    }
    return new Promise((resolve, reject) => {
      service.submit(data).then(res => {
        let {data} = res
        if (data.success && data.datas.payStr) {
          // 提交成功，清除优惠券码或选中优惠券信息
          commit(UPDATE_SUBIMT_COUPON, {couponInfo: {}})
          // 刷新优惠券（微信提交成功到微信后，当前webview不刷新）
          if (client.user.token && data.datas.login) {
            dispatch('fetchProductCoupon')
          }
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  }
  // 请求订单列表
  , getOrderRecord({rootState, commit}, {offset, pageSize}) {
    let {client} = rootState
    return new Promise((resolve, reject) => {
      service.searchRecord({
        authToken: client.user.token,
        loginUserId: client.user.userID,
        offset,
        pageSize
      })
        .then(({data}) => {
          let {success, datas} = data
          if (success) {
            commit(UPDATE_ORDER_LIST, datas)
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(e => reject(e))
    })
  }
  // 清空订单列表
  , clearOrderList({commit}) {
    commit(CLEAR_ORDER_LIST)
  }
  // 取消订单
  , closeOrder({rootState}, {orderNo}) {
    let {client} = rootState
    return new Promise((resolve, reject) => {
      service.closeOrder({
        authToken: client.user.token,
        orderNo
      })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(e => reject(e))
    })
  },
  removeOrder({rootState}, {orderNo}) {
    let {client} = rootState
    return new Promise((resolve, reject) => {
      service.removeOrder({
        authToken: client.user.token,
        orderNo
      })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(e => reject(e))
    })
  },
  // 获取订单支付方式
  getPayMethods({commit, dispatch, rootState}, {orderNo}) {
    const {client} = rootState
    return new Promise((resolve, reject) => {
      service.getPayMethods({
        orderNo
      })
        .then(({data}) => {
          if (data.success) {
            let payArr = util.filterPayMethodList(data.datas, client.client.env, config.showCMBpay, config.showABCWallet)
            // console.log("payArr==",payArr)
            commit(SET_SECOND_PAYMETHOD_LIST, payArr)
            dispatch('selectSecondPayment', {index: 0})
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(e => reject(e))
    })
  },
  // 选择支付方式
  selectSecondPayment({commit}, {index}) {
    commit(SELECT_SECOND_PAYMENT, {index})
  },
  secondPay({state, rootState}, {orderNo}) {
    const {client} = rootState
    const path = window.location.origin + window.location.pathname
    let {secondPayMethodsList, secondPaySelectedIndex, secondPaymentSubCode} = state
    let pay = {
      payMethodCode: secondPayMethodsList[secondPaySelectedIndex].paymentMethodId,
      payMethodSubCode: secondPaymentSubCode,
      payReturnUrl: path + '#/result?state=success',
      unpayReturnUrl: path + '#/detail'
    }
    if (client.client.env === 'wxMini') {
      pay.payMethodSubCode = 'WXPAY_MINI'
    }
    if (pay.payMethodCode === 'CMBPAY') {
      // pay.payMethodSubCode = 'CMBPAY_APP_JH'
      pay.payMethodSubCode = client.client.env === 'app' ? 'CMBPAY_APP_JH' : 'CMBPAY_H5_JH'
    }

    // 改改改
    // 农行sdk支付
    if (pay.payMethodCode === 'ABCPAY') {
      pay.payMethodSubCode = client.client.env === 'app' ? 'ABCPAY_SDK' : config.ABCPaySubCode
    }
    // 农行钱包支付
    // if (pay.payMethodCode === 'ABCPAY_WALLET') {
    //   pay.payMethodCode = 'ABCPAY'
    // }
    
    return new Promise((resolve, reject) => {
      service.secondPay({
        orderNo,
        pay
      })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(e => reject(e))
    })
  }
  , clearOrderInfo() {
    util.removeStorageInfo('productInfo')
    util.removeStorageInfo('senPay')
    window.sessionStorage.removeItem('tradeId')
    window.sessionStorage.removeItem('wxPayInfo')
    window.sessionStorage.removeItem('wxPayInfoTime')
  }
  // 微信小程序支付
  , wxMiniPay(data, json) {
    try {
      /* eslint-disable no-undef */
      const path = window.location.origin + window.location.pathname
      wx.miniProgram.postMessage({
        data: JSON.stringify({
          payInfo: JSON.stringify(Object.assign({}, json, {
            successUrl: path + '#/result?state=success',
            failUrl: path + '#/detail'
          }))
        })
      })
      /* eslint-disable no-undef */
      wx.miniProgram.navigateBack({
        delta: 1
      })
    } catch (e) {
      return ''
    }
  }
}
